import { Component } from '@angular/core';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ContentDashboardComponent } from './content-dashboard/content-dashboard.component';
import { ApiService } from '../../Services/api.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-content-manage',
  standalone: true,
  imports: [NzBreadCrumbModule,NzSpinModule, NzButtonModule, NzInputModule, NzIconModule, 
    ContentDashboardComponent],
  templateUrl: './content-manage.component.html',
  styleUrl: './content-manage.component.scss'
})
export class ContentManageComponent {

  constructor(public api:ApiService){

  }

  ngOnInit(): void {
    
  } 

}
